/* eslint-disable no-mixed-operators */
import { IUser } from "@microsoft/mgt-react"
import { getGroupsByName, getMembersOfGroup } from "../lib/graph"
import { convertToIDMGroupName } from "../utils/converter"

export const getLLDivisionAdmin = async (division: string) => {
    let idmGroup = convertToIDMGroupName(division, "ll")
    try {
        let groups: any[] = await getGroupsByName(idmGroup)
        let members = !!groups && groups.length > 0 && await getMembersOfGroup(groups[0].id)
        return (!!members && members.length > 0 && members[0] || { displayName: `${idmGroup} (No members found)` }) as IUser ;
    } catch (error) {
        console.log(error);
        return { displayName: `${idmGroup} (No members found)` };
    }
}

